module.exports = __webpack_public_path__ + "static/Ana-Ivanchikj-c338a5f57c34e255660dd2a2f90482ee.jpg";